import React from "react";
import Navbar from "../components/Navbar";
import Contact from "../components/Contact";
import "../styles/global.css";
import Clients from "../components/Clients";
import Footer from "../components/Footer";
import { useLocation } from "react-router";
import ContactUs from "../components/ContactUs";
import { Helmet } from "react-helmet-async";

const Contactpage = () => {
  const isUAEPath = window.location.pathname.startsWith("/uae");
  const currentLocation = useLocation();

  const basePath = currentLocation.pathname.startsWith("/uae") ? "/uae" : "/";
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  const email = isUAEPath ? "ceo@timewatchuae.com" : "sales@timewatchindia.com";

  const phone = isUAEPath ? "+971-54-777-0637" : "+91-95999 53923";

  return (
    <>
      <Helmet>
        <title>Contact Us | TimeWatch Infocom</title>
        <meta
          name="description"
          content="Get in touch with TimeWatch Infocom, your trusted provider of biometric solutions, access control systems, and smart security technologies in Delhi. Whether you need information about our advanced security solutions, time attendance systems, entrance automation, or parking management services, our team is here to assist you. Reach out today for inquiries, support, or to discuss tailored security solutions for your business. Our experts are ready to provide reliable, efficient, and innovative security technology to meet your unique needs. Contact us now for professional guidance and customer service."
        />
        <link
          rel="canonical"
          href="https://www.timewatchindia.com/contact-us"
        />
      </Helmet>
      <header className="navbar">
        <Navbar />
      </header>

      <div className="content-container">
        {/* <section className="contact">
          <section className="contact-info-boxes container my-5">
            <div className="row text-center">
              <div className="col-md-4">
                <a
                  href={`mailto:${email}`}
                  className="text-decoration-none"
                  style={{ color: "black" }}
                >
                  <div className="p-3 border rounded">
                    <h5>Email</h5>
                    <p>{email} </p>
                  </div>
                </a>
              </div>
              <div className="col-md-4">
                <a
                  href={`tel: ${phone}`}
                  className="text-decoration-none"
                  style={{ color: "black" }}
                >
                  <div className="p-3 border rounded">
                    <h5>Contact</h5>
                    <p>{phone} </p>
                  </div>
                </a>
              </div>

              {!isUAEPath && (
                <div className="col-md-4">
                  <a
                    href="https://wa.me/919599953923"
                    className="text-decoration-none"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: "black" }}
                  >
                    <div className="p-3 border rounded">
                      <h5>WhatsApp</h5>
                      <p>+91-95999-53923</p>
                    </div>
                  </a>
                </div>
              )}
            </div>
          </section>

          <Contact />
        </section> */}
        <ContactUs />
        {/* <section className="client">
          <Clients />
        </section> */}
      </div>

      <footer className="footer">
        <Footer />
      </footer>
    </>
  );
};

export default Contactpage;
